<template>
  <div class="introduction-content3">
    <div class="title-container">
      <div class="title-text">主要产品</div>
      <div class="title-text-en">Main Products</div>
    </div>
    <div class="content-container">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionContent3',
  data() {
    return {
      content: '松鼠互娱酒吧大屏互动软件：大屏场景下互动服务平台；提供3D签到、签到簿 、倒计时 、弹幕上墙 、霸屏 、抢荭包 、拔河 、赛车 、数钱、幸运夺宝、摇一摇、荭包雨 、点歌、抽奖 、投票、猜明星、猜成语、猜英雄、猜歌名、火眼金睛等现场互动功能。 现场只需一块LED大屏幕、一台操作电脑就能引爆现场气氛，High翻全场。',
    };
  },
};
</script>

<style lang="less" scoped>
.introduction-content3 {
  width: 100%;
  height: auto;
  margin-top: 90px;
  
  .title-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    .title-text {
      font-weight: 700;
      font-size: 32px;
      line-height: 1;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .title-text-en {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.5;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-top: 12px;
    }
  }
  
  .content-container {
    width: 1150px;
    background: linear-gradient(270deg, rgba(102,27,135,0.5) 0%, rgba(20,79,139,0.5) 100%);
    border-radius: 12px;
    padding: 47px 60px;
    margin: 48px auto 0;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 30px;
    text-align: justify;
  }
}
</style>
